import { render } from "./TransactionItem.vue?vue&type=template&id=5af9bbac&scoped=true"
import script from "./TransactionItem.vue?vue&type=script&lang=js"
export * from "./TransactionItem.vue?vue&type=script&lang=js"

import "./TransactionItem.vue?vue&type=style&index=0&id=5af9bbac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af9bbac"]])

export default __exports__